var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-previous-exhibitions-boxes__amount-hits-showing-wrapper"},[_c('p',{staticClass:"hiq-previous-exhibitions-boxes__amount-hits-showing-text"},[_vm._v(" "+_vm._s(`Visar ${_vm.amountShowing} av ${_vm.totalItems}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }